module.exports = __webpack_public_path__ + "assets/img/可出货数量.9cae3b32.svg";